import request from '@/utils/request'

export function login (params) {
  return request({
    method: 'get',
    params: {
      r: 'login/account',
      ...params
    }
  })
}

// 实名认证
export function verified (params) {
  return request({
    method: 'get',
    params: {
      r: 'user/real-name',
      ...params
    }
  })
}

export function logout () {
  return request({
    method: 'get',
    params: {
      r: 'user/out'
    }
  })
}

// 手机号登陆
export function phoneLogin (params) {
  return request({
    method: 'get',
    params: {
      r: 'login/phone',
      ...params
    }
  })
}

// 一键登录
export function oneLogin (params) {
  return request({
    method: 'get',
    params: {
      r: 'login/one-click-login',
      ...params
    }
  })
}
